export const mapGeolocationToAddress = (googleAddress, { location }) => {
  const findType = type =>
    googleAddress.find(({ types }) => types.indexOf(type) > -1);

  const getValue = validTypes => {
    const foundValue = validTypes.map(findType).find(Boolean);
    return foundValue ? foundValue.long_name : null;
  };

  return {
    geoLat: location.lat(),
    geoLng: location.lng(),
    street: getValue(["route", "street_address"]),
    streetNumber: getValue(["street_number"]),
    country: getValue(["country"]),
    postcode: getValue(["postal_code"]),
    city: getValue([
      "locality",
      "sublocality",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "postal_town",
    ]),
  };
};
